import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import DashboardWithNavbar from './components/Navbar';
import LoginForm from './components/LoginForm';

// Catalog
import ProductsList from './components/Productslist';
import Categories from './components/Categories';
import Manufacturers from './components/manufactures';
import ProductReviews from './components/ProductsReviwes';
import ProductTags from './components/ProductsTags';

// Sales
import Orders from './components/Orders';
import ShipmentsPage from './components/Shipment';
import ReturnRequests from './components/ReturnRequest';
import RecurringPayments from './components/RecurringPayments';

// Customers
import Customers from './components/Customers';
import OnlineCustomers from './components/OnlineCustomers';
import CustomerRoles from './components/CustomerRole';
import ActivityLog from './components/ActivityLog';

// Promotions
import Discountsone from './promotions/Discounts';
import Affiliates from './promotions/Affiliates';
import NewsletterSubscriber from './promotions/NewsletterSubscribers';
import Campaign from './promotions/Campaigns';

// Content Management
import TopicsManager from './content Mangement/TopicsManager';
import MessageTemplatesManager from './content Mangement/MessageTemplatesManager';
import NewsItemsManagers from './content Mangement/NewsItemsManager';
import NewsCommentsManagers from './content Mangement/NewsCommentsManager';
import BlogPosts from './content Mangement/BlogPostsManager';
import BlogComment from './content Mangement/BlogComments';
import PollsManager from './content Mangement/PollsManager';
import Forums from './content Mangement/Forums';

// Configuration
import CountriesManagers from './Configuration/CountriesManager';
import CurrenciesManagers from './Configuration/CurrenciesManager';
import EmailAccountsManagers from './Configuration/Emailaccounts';
import LanguagesManagers from './Configuration/LanguagesManager';
import PaymentRestriction from './Configuration/Payment restrictions';
import PaymentMethodsManagers from './Configuration/PaymentMethodsManager';
import Store from './Configuration/Stores';
import TaxProviders from './Configuration/TaxProviders';
import TaxCategories from './Configuration/TaxCategories';

// Reports
import BestsellersReports from './reports/bestseller';
import CountrySalesReports from './reports/CountrySalesReport';
import CustomersByOrderTotals from './reports/customers-by-order-total';
import CustomersByNumberOfOrder from './reports/CustomersByNumberOfOrders';
import LowStockReports from './reports/lowstock';
import ProductsNeverPurchase from './reports/neverpurched';
import PowerBIPlugins from './reports/powerbi';
import RegisteredCustomersReports from './reports/registered-customers';
import SalesSummary from './reports/SalesSummary';

// System
import LogPageone from './System Report/log';
import MaintenancePage from './System Report/MaintenancePage';
import MessageQueue from './System Report/MessageQueue';
import ScheduleTask from './System Report/ScheduleTasks';
import SeoFriendlyNamesPage from './System Report/SeoFriendlyNamesPage';
import SystemInformation from './System Report/SystemInformation';
import TemplatesPage from './System Report/TemplatesPage';
import Warning from './System Report/Warnings';
import Dashboard from './components/DashBoard';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public Route */}
        <Route path='/' element={<LoginForm />} />

        {/* Dashboard Layout */}
        <Route path='/' element={<DashboardWithNavbar />}>
       
          <Route path='dashboard' element={<Dashboard />} />
          {/* Catalog */}
          <Route path='catalog/products' element={<ProductsList />} />
          <Route path='catalog/categories' element={<Categories />} />
          <Route path='catalog/manufacturers' element={<Manufacturers />} />
          <Route path='catalog/reviews' element={<ProductReviews />} />
          <Route path='catalog/tags' element={<ProductTags />} />

          {/* Sales */}
          <Route path='sales/orders' element={<Orders />} />
          <Route path='sales/shipments' element={<ShipmentsPage />} />
          <Route path='sales/returns' element={<ReturnRequests />} />
          <Route path='sales/payments' element={<RecurringPayments />} />

          {/* Customers */}
          <Route path='customers/list' element={<Customers />} />
          <Route path='customers/online' element={<OnlineCustomers />} />
          <Route path='customers/roles' element={<CustomerRoles />} />
          <Route path='customers/logs' element={<ActivityLog />} />

          {/* Promotions */}
          <Route path='promotions/discounts' element={<Discountsone />} />
          <Route path='promotions/affiliates' element={<Affiliates />} />
          <Route path='promotions/newsletter' element={<NewsletterSubscriber />} />
          <Route path='promotions/campaigns' element={<Campaign />} />

          {/* Content Management */}
          <Route path='content/pages' element={<TopicsManager />} />
          <Route path='content/message' element={<MessageTemplatesManager />} />
          <Route path='content/items' element={<NewsItemsManagers />} />
          <Route path='content/news' element={<NewsCommentsManagers />} />
          <Route path='content/posts' element={<BlogPosts />} />
          <Route path='content/comments' element={<BlogComment />} />
          <Route path='content/polls' element={<PollsManager />} />
          <Route path='content/forums' element={<Forums />} />

          {/* Configuration */}
          <Route path='configuration/email-accounts' element={<EmailAccountsManagers />} />
          <Route path='configuration/stores' element={<Store />} />
          <Route path='configuration/countries' element={<CountriesManagers />} />
          <Route path='configuration/languages' element={<LanguagesManagers />} />
          <Route path='configuration/currencies' element={<CurrenciesManagers />} />
          <Route path='configuration/payment-methods' element={<PaymentMethodsManagers />} />
          <Route path='configuration/payment-restrictions' element={<PaymentRestriction />} />
          <Route path='configuration/tax-providers' element={<TaxProviders />} />
          <Route path='configuration/tax-categories' element={<TaxCategories />} />

          {/* Reports */}
          <Route path='reports/powerbi' element={<PowerBIPlugins />} />
          <Route path='reports/sales-summary' element={<SalesSummary />} />
          <Route path='reports/low-stock' element={<LowStockReports />} />
          <Route path='reports/bestsellers' element={<BestsellersReports />} />
          <Route path='reports/country-sales' element={<CountrySalesReports />} />
          <Route path='reports/registered-customers' element={<RegisteredCustomersReports />} />
          <Route path='reports/customers-by-order-total' element={<CustomersByOrderTotals />} />
          <Route path='reports/products-never-purchased' element={<ProductsNeverPurchase />} />
          <Route path='reports/customers-by-number-of-orders' element={<CustomersByNumberOfOrder />} />

          {/* System */}
          <Route path='system/log' element={<LogPageone />} />
          <Route path='system/templates' element={<TemplatesPage />} />
          <Route path='system/maintenance' element={<MaintenancePage />} />
          <Route path='system/search-engine-friendly-page-names' element={<SeoFriendlyNamesPage />} />
          <Route path='system/system-information' element={<SystemInformation />} />
          <Route path='system/warning' element={<Warning />} />
          <Route path='system/schedule-tasks' element={<ScheduleTask />} />
          <Route path='system/message-queue' element={<MessageQueue />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
